import React, { useState } from 'react';

// Librairies
import { InputBase, Box } from '@mui/material';
import clsx from 'clsx';

// Components
import SubHeader from '../../../components/subHeader';
import TmsHeader from '../../../components/header';
import Options from '../../../components/Options';
import CustomDropdown from '../../../components/customDropdown';
import CommonTable from '../../../components/CommonTable';
import Select from '../../../components/Select';

// Styles
import { useStyles } from './style';

const ITEMS: Array<string> = [
  'Read Id',
  'Ground Status',
  'Status Word',
  '',
  'Authorize',
  'Unauthorize', '', 'Reboot', '', 'Clear'];

const VipScullyCommunicationsScreen: React.FC = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOptionClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <TmsHeader />
      <SubHeader title="VIP Scully Communications">
        <Options
          handleClick={handleOptionClick}
          anchorEl={anchorEl}
          onClose={handleCloseMenu}
          openDialog={() => null}
          items={ITEMS}
          onItemClick={(_menuId:number) => handleCloseMenu()}
        />

      </SubHeader>
      <div className={clsx(classes.container)}>

        <CustomDropdown
          label="Bay - Trailer Id"
          name="Bay - Trailer Id"
          defaultValue="01-001"
          onChange={() => null}
          size="100%"
          options={[{ label: '01-001', value: '01-001' }]}
          isDisabled={false}
        />
      </div>
      <Box className={classes.boxLine} />
      <div
        className={clsx('flexStartSpaceBetweenRow', classes.container)}
      >
        <div className={clsx('flexRow')}>
          <span className={classes.label}>Records :</span>
          <Select
            options={['Auto', 10, 20, 25, 35, 50, 'All']}
            width={200}
            value="Auto"
          />
        </div>
        <div className="flexRow">
          <span className={classes.label}>Search :</span>
          <InputBase className={classes.searchInput} />
        </div>
      </div>
      <CommonTable handleClickRow={() => null} />
    </>
  );
};

export default VipScullyCommunicationsScreen;
